/* eslint-disable camelcase */
// import Alert from 'react-s-alert';

import { ServerIp } from '../constants/env';

export const createMesurementsImage = (imageArray, id) => (dispatch) => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');

  fetch(`${ServerIp}/api/v2/element_images`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'cache-control': 'no-cache',
      Authorization: `Token token="${token}", identifier="${user}"`,
    },
    body: JSON.stringify({ image: { measurement_id: id, image_base64s: imageArray } }),
  }).then((res) => {
    if (res.status < 400) {
      res.json().then((data) => {
        // Alert.success('Uploading in progress');
        dispatch({
          type: 'ADD_IMAGE',
          payload: data,
        });
      });
    } else {
      dispatch({
        type: 'GET_FAIL',
        payload: 'Failed to uploud image, please try again!',
      });
      setTimeout(() => {
        dispatch({
          type: 'RESET_ERROR',
        });
      }, 50);
    }
  });
};


export const handleRotateImage = (id, rotation) => (dispatch) => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');

  fetch(`${ServerIp}/api/v2/element_images/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Token token="${token}", identifier="${user}"`,
    },
    body: JSON.stringify({ image: { id, rotation } }),
  }).then((res) => {
    if (res.status === 200) {
      dispatch({
        type: 'HANDLE_ROTATE_IMAGE',
        payload: {rotation, id},
      });
    } else {
      dispatch({
        type: 'GET_FAIL',
        payload: 'Failed to rotate image, please try again!',
      });
      setTimeout(() => {
        dispatch({
          type: 'RESET_ERROR',
        });
      }, 50);
    }
  });
};

export const handleRemoveImage = (id) => (dispatch) => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');

  fetch(`${ServerIp}/api/v2/element_images/${id}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Token token="${token}", identifier="${user}"`,
    },
    body: JSON.stringify({ image: { id } }),
  }).then((res) => {
    if (res.status === 200) {
      dispatch({
        type: 'REMOVE_IMAGE',
        payload: id,
      });
    } else {
      dispatch({
        type: 'GET_FAIL',
        payload: 'Failed to delete image, please try again!',
      });
      setTimeout(() => {
        dispatch({
          type: 'RESET_ERROR',
        });
      }, 50);
    }
  });
};



// WEBPACK FOOTER //
// ./src/actions/images.js